export default __webpack_public_path__ + "img/slideshow/fac/1.png";